export const clientHasConfirmedProjects = (client) => {
    if (!client) return false;

    const confirmedProjectsCount = Number(client.confirmed_projects_count || 0);
    const hasConfirmedProjects = client.has_confirmed_projects;

    return (
        confirmedProjectsCount > 0 ||
        hasConfirmedProjects === true ||
        hasConfirmedProjects === 1 ||
        hasConfirmedProjects === '1' ||
        hasConfirmedProjects === 'true'
    );
};

const normalizeComparableId = (value) => {
    if (value === null || value === undefined) return null;
    return String(value);
};

const compactIdList = (values) => {
    if (!Array.isArray(values)) {
        return [];
    }

    const seen = new Set();
    return values
        .filter(id => id !== null && id !== undefined && id !== '')
        .filter(id => {
            const key = String(id);
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
};

const firstNonEmptyIdList = (...sources) => {
    for (const source of sources) {
        const ids = compactIdList(source);
        if (ids.length > 0) {
            return ids;
        }
    }

    return [];
};

export const findClientById = (clients, clientId) => {
    const targetId = normalizeComparableId(clientId);
    if (!targetId || !Array.isArray(clients)) {
        return null;
    }

    return clients.find(client => (
        normalizeComparableId(client?.id) === targetId ||
        normalizeComparableId(client?.client_id) === targetId
    )) || null;
};

export const buildCreatedClientForProjectAutoFill = (responseData, values = {}) => {
    const responseClient = responseData?.data?.client ||
        responseData?.client ||
        {};
    const selectedIndustryIds = compactIdList(values.industry_classification_ids);
    const industryIds = firstNonEmptyIdList(
        responseClient.industry_ids,
        responseClient.industry_classification_ids,
        selectedIndustryIds
    );

    return {
        ...responseClient,
        id: responseClient.id ?? responseData?.id ?? responseData?.data?.id,
        name: responseClient.name || values.name,
        industry_ids: industryIds,
        industry_classification_ids: industryIds,
    };
};

export const mergeCreatedClientForLookup = (clients, createdClient) => {
    const existingClients = Array.isArray(clients) ? clients : [];
    const createdClientId = normalizeComparableId(createdClient?.id ?? createdClient?.client_id);

    if (!createdClientId) {
        return existingClients;
    }

    return [
        createdClient,
        ...existingClients.filter(client =>
            normalizeComparableId(client?.id ?? client?.client_id) !== createdClientId
        ),
    ];
};

export const getClientIndustryIds = (client) => {
    const directIndustryIds = compactIdList(client?.industry_ids);
    if (directIndustryIds.length > 0) {
        return directIndustryIds;
    }

    const classificationIds = compactIdList(client?.industry_classification_ids);
    if (classificationIds.length > 0) {
        return classificationIds;
    }

    const relationIndustryIds = compactIdList(
        client?.client_industry_classification?.map(cic =>
            cic?.industry_classification_id ?? cic?.industry_classification?.id
        )
    );
    if (relationIndustryIds.length > 0) {
        return relationIndustryIds;
    }

    return compactIdList(
        client?.industries?.map(industry =>
            typeof industry === 'object' && industry !== null
                ? industry.id ?? industry.industry_classification_id
                : null
        )
    );
};

export const resolveClientAutoFillUpdates = (selectedClientData, currentAutoFilledFields) => {
    const nextAutoFilledFields = new Set(currentAutoFilledFields || []);
    const fieldValues = {};

    if (selectedClientData && clientHasConfirmedProjects(selectedClientData)) {
        fieldValues.leadSource = 'client';
        nextAutoFilledFields.add('leadSource');
    } else if (nextAutoFilledFields.has('leadSource')) {
        fieldValues.leadSource = undefined;
        nextAutoFilledFields.delete('leadSource');
    }

    const industryIds = getClientIndustryIds(selectedClientData);

    if (industryIds.length > 0) {
        fieldValues.projectIndustries = industryIds;
        nextAutoFilledFields.add('projectIndustries');
    } else if (nextAutoFilledFields.has('projectIndustries')) {
        fieldValues.projectIndustries = undefined;
        nextAutoFilledFields.delete('projectIndustries');
    }

    return {
        fieldValues,
        autoFilledFields: nextAutoFilledFields,
    };
};
